import { TG } from "../api/api";

export const handleInvite = (link:string, text:string) => {
    const shareUrl = `https://t.me/share/url?url=${encodeURIComponent(link)}&text=${encodeURIComponent(text)}`;
    TG?.openTelegramLink(shareUrl);
};